import { withDefault } from '../core/util';

/*
  The below functions work together with 
  http://assets.adobedtm.com/launch-EN9221f7d4013a4cb2888e14c07b4ea68c.min.js 
  (src'ed on public/index.html page)
*/

export const dispatchPageLoad = page => {
  const event = new CustomEvent('pageLoad', {
    detail: {
      page
    }
  });

  window.dispatchEvent(event);
};

window.dispatchPageLoad = dispatchPageLoad;

export const dispatchOverlayLoad = modalName => {
  const event = new CustomEvent('overlayLoad', {
    detail: {
      overlay: modalName
    }
  });

  document.body.dispatchEvent(event);
};

export const dispatchErrorLoad = error => {
  const event = new CustomEvent('errorLoad', {
    detail: {
      error
    }
  });

  document.body.dispatchEvent(event);
};

export const dispatchProfileErrorEvent = errorMessage => {
  const GENERIC_PROFILE_SVC_ERROR = 'Profile service failure.';

  const profileSvcErrorEvent = new CustomEvent('errorLoad', {
    detail: {
      error: withDefault(errorMessage, GENERIC_PROFILE_SVC_ERROR)
    }
  });

  document.body.dispatchEvent(profileSvcErrorEvent);
};

export const dispatchFONASUPushToWebCustomEvent = () => {
  const foNASUSuccessfulPushToWebEvent = new CustomEvent('actionComplete', {
    detail: {
      action: 'OpenAccount|MutualFund'
    }
  });

  document.body.dispatchEvent(foNASUSuccessfulPushToWebEvent);
};

const instantiateAnalyticsDataLayer = data => {
  // Adobe code
  const id = Math.random()
    .toString(36)
    .substr(2, 9);

  const { clientTier, ...restOfData } = data;

  if (Number(clientTier) > 0) {
    window.metricsData.user = {
      clientTier
    };
  }

  window.metricsData.nasu = {
    ...restOfData,
    id
  };
};

const setNASUQualtricsDataLayer = data => {
  // Qualtrics code
  const {
    accountType: nasuAccountType,
    productType: nasuProductType,
    sourceType: nasuSourceType,
    userType: nasuUserType,
    clientTier
  } = data;

  const nasuQualtricsData = {
    nasuAccountType,
    nasuProductType,
    nasuSourceType,
    nasuUserType,
    ...(Number(clientTier) > 0 && {
      clientTier
    })
  };

  if (window?.trpQualtrics) {
    window.trpQualtrics = {
      ...window.trpQualtrics,
      ...nasuQualtricsData
    };
  } else if (window) {
    window.trpQualtrics = { ...nasuQualtricsData };
  }
};

export const analyticsDataLayer = async data => {
  // Adobe analytics code
  // If first time, create data layer
  if (!window.metricsData || !window.metricsData.nasu) {
    instantiateAnalyticsDataLayer(data);
  }

  const { clientTier, ...restOfData } = data;

  if (Number(clientTier) > 0) {
    window.metricsData.user = {
      clientTier
    };
  }

  Object.keys(restOfData).forEach(key => {
    window.metricsData.nasu[key] = restOfData[key];
  });

  // Qualtrics code
  setNASUQualtricsDataLayer(data);
};
